export default {
  rowLabel: "product {{name}}",
  products: "Products",
  product: "Product",
  newProduct: "New Product",
  columns: {
    name: "Name",
    sku: "SKU",
    unitPrice: "Price",
    is_archived: "Status",
    actions: "Actions",
  },
  active: "Active",
  archived: "Archived",
  showArchived: "Show archived",
  searchPlaceholder: "Search by name or SKU",
  form: {
    name: "Name",
    sku: "SKU",
    skuPlaceholder: "Optional",
    description: "Description",
    unitPrice: "Price",
    currency: "Currency",
    currencyPlaceholder: "Select a currency...",
    nameRequired: "Enter a product name.",
    currencyRequired: "Choose a currency.",
    priceInvalid: "Enter a price of zero or more.",
    submitCreate: "Create Product",
    submitUpdate: "Save Changes",
    saving: "Saving the product...",
    saveFailedTitle: "The product was not saved",
    saveFailed:
      "Sorry, this product could not be saved due to an error on our end. Please try again later.",
    saveForbidden: "You no longer have permission to change products.",
    saveNotFound: "This product no longer exists. It may have been deleted.",
  },
  modal: {
    createTitle: "New Product",
    createDescription: "Add an item or service to your price list.",
    editTitle: "Edit Product",
    editDescription: "Update this item on your price list.",
  },
  create: {
    submitting: "Creating the product...",
    created: "Product created successfully",
    createdMessage: "It’s ready to add to invoices and contracts.",
  },
  rowActions: {
    menuLabel: "Product actions",
    edit: "Edit",
    archive: "Archive",
    unarchive: "Unarchive",
  },
  empty: {
    title: "No products yet",
    subtitle:
      "Add the things your organization sells, then reuse them on invoices and contracts.",
    create: "Create Product",
    import: "Import from CSV",
  },
  confirmDeleteTitle: "Delete Product",
  confirmDeleteTitle_plural: "Delete Products",
  confirmDeleteMessage: "Are you sure you want to delete this product?",
  confirmDeleteMessage_plural:
    "Are you sure you want to delete these {{count}} products?",
  productArchived: "Product archived successfully",
  productUnarchived: "Product unarchived successfully",
  productsDeleted: "Products deleted successfully",
};
